const ppBookingFlowPaths = ['/choose-your-room', '/confirm-your-stay', '/personalize-your-stay'];

export function selectPreferredPartnerDetails({ preferredPartnerDetails }) {
	return preferredPartnerDetails.data;
}

export function selectIsPreferredPartners(state) {
	const pathname = state.router?.location?.pathname || '';
	const ppDetailsLoaded =
		state.preferredPartnerDetails?.data?.success === 'true' &&
		ppBookingFlowPaths.some(path => pathname.includes(path));

	return (
		Boolean(state.router?.location?.query?.ppMode) ||
		Boolean(state.bookings?.bookingInProgressSearchParams?.ppMode) ||
		ppDetailsLoaded
	);
}
